// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"2d600e29","787":"f11eb626","952":"d688f22b"}[chunkId] + ".chunk.js";
};